export const MESSAGE_EVENTS = {
  NICE_SUCCESS: 'NICE_SUCCESS',
};
